import { useMemo } from 'react';

import { getABNVariant } from '~/src/helpers/abn-tests';

export const useLabelAbnTest = () => useMemo(() => getABNVariant('label_thank_you_page') === 'label_thank_you_page_on', []);
